export default __webpack_public_path__ + "static/quote-bg-1-min-e1562e902f42b40237b571b23a1d444f.png";